exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".not-found-404{display:block}.not-found-404 .title{font-weight:300;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/shared/pages/not-found-404-page.cmp.scss
// module id = 840
// module chunks = 1